<div [class]=" 'chip text ' + color + ' ' + size + (textColor ? ' text-' + textColor : '') + (disabled ? ' disabled' : '')"
    [style.backgroundColor]="hexColor" [matTooltip]="tooltip">
    <mat-icon *ngIf="icon" [ngClass]="icon === 'sync' ? 'loading-spin' : ''" fontIcon="{{ icon }}"></mat-icon>
    <mat-icon *ngIf="svgIcon" svgIcon="{{ svgIcon }}"></mat-icon>
    <span *ngIf="text">{{text}}</span>
    <ng-content></ng-content>
</div>